import numeral from 'numeral'

export const formatDate = (date, error = 'Invalid date') => {
  if (!date) return error

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  return `${months[month]} ${day}, ${year}`
}

export const formatNumber = (value) => {
  return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
}

export const formatDateTime = (date, error = 'Invalid date') => {
  if (!date) return error
  var localDateTime = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const month = localDateTime.getMonth()
  var day = localDateTime.getDate()
  var hour = localDateTime.getHours()
  if (hour >= 24) {
    day = day + 1
  }
  var amPm = 'AM'
  if (hour > 12) {
    hour = hour % 12
    amPm = 'PM'
  } else if (hour === 12) {
    amPm = 'PM'
  }
  const minutes = localDateTime.getMinutes()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm

  return `${months[month]} ${day}, ${time}`
}

export const formatDateTimeWithYear = (date, error = 'Invalid date') => {
  if (!date) return error
  var dateObject = new Date(date)
  var localDateTime = new Date(Date.UTC(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), dateObject.getHours(), dateObject.getMinutes(), dateObject.getSeconds()))
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const year = localDateTime.getFullYear()
  const month = localDateTime.getMonth()
  var day = localDateTime.getDate()
  var hour = localDateTime.getHours()
  if (hour >= 24) {
    day = day + 1
  }
  var amPm = 'AM'
  if (hour > 12) {
    hour = hour % 12
    amPm = 'PM'
  } else if (hour === 12) {
    amPm = 'PM'
  }
  const minutes = localDateTime.getMinutes()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm

  return `${months[month]} ${day}, ${year}, ${time}`
}

export const formatDateTimeNoOffset = (date, error = 'Invalid date') => {
  if (!date) return error

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const month = date.getMonth()
  var day = date.getDate()
  var hour = date.getHours()
  var amPm = 'AM'
  if (hour > 12) {
    hour = hour % 12
    amPm = 'PM'
  } else if (hour === 12) {
    amPm = 'PM'
  }
  const minutes = date.getMinutes()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm

  return `${months[month]} ${day}, ${time}`
}

export const formatEchartsDateTime = (date, error = 'Invalid date') => {
  if (!date) return error

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  var hour = date.getHours()
  const minutes = date.getMinutes()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2)

  return `${year}/${month}/${day} ${time}`
}

// export const formatEchartsDateTimeNoOffset = (date, error = 'Invalid date') => {
//   if (!date) return error

//   const year = date.getFullYear()
//   const month = date.getMonth() + 1
//   const day = date.getDate()
//   var hour = date.getHours()
//   const minutes = date.getMinutes()
//   const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2)

//   return `${year}/${month}/${day} ${time}`
// }

export const formatEchartsDate = (date, error = 'Invalid date') => {
  if (!date) return error

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${year}/${month}/${day}`
}

export const formatEchartsMonth = (date, error = 'Invalid date') => {
  if (!date) return error

  const year = date.getFullYear()
  const month = date.getMonth() + 1

  return `${year}/${month}`
}

export const formatTime = (date, error = 'Invalid date') => {
  if (!date) return error
  var hour = date.getHours()
  const minutes = date.getMinutes()
  var amPm = 'AM'
  if (hour > 12) {
    hour = hour % 12
    amPm = 'PM'
  } else if (hour === 12) {
    amPm = 'PM'
  }
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + amPm

  return `${time}`
}

export const formatTimeWithSeconds = (date, error = 'Invalid date') => {
  if (!date) return error

  var hour = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const time = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)

  return `${time}`
}

export const formatWOM = (date, error = 'Invalid date') => {
  if (!date) return error

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  var week = date.week
  var month = months[date.month - 1]
  var year = date.year

  return 'Week ' + week + ', ' + month + ' ' + year
}

export const formatMOY = (date, error = 'Invalid date') => {
  if (!date) return error

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  var month = months[date.month]
  var year = date.year

  return month + ' ' + year
}

export const getQueryFromDateTime = (date, hours, minutes, seconds, error = 'Invalid date') => {
  if (!date) return error

  var dateArray = date.split('-')
  var correctDateString = ''
  correctDateString = new Date(dateArray[0], dateArray[1] - 1, dateArray[2], hours, minutes, seconds)
  var day = correctDateString.getUTCDate()
  var month = correctDateString.getUTCMonth()
  var year = correctDateString.getUTCFullYear()
  var hour = correctDateString.getUTCHours()
  var minute = correctDateString.getUTCMinutes()
  var second = correctDateString.getSeconds()
  var queryString = year + '-' + ('0' + (month + 1)).slice(-2) + '-' + ('0' + day).slice(-2) + ' ' + ('0' + hour).slice(-2) + ':' + ('0' + minute).slice(-2) + ':' + ('0' + second).slice(-2)
  return queryString
}

export const getLocalDate = (date, error = 'Invalid date') => {
  var newDate = new Date(date)
  var timeZoneOffsetHours = newDate.getTimezoneOffset() / 60
  var timeZoneOffsetMinutes = newDate.getTimezoneOffset() % 60
  newDate.setHours(newDate.getHours() - timeZoneOffsetHours)
  newDate.setMinutes(newDate.getMinutes() - timeZoneOffsetMinutes)
  return newDate
}



// WEBPACK FOOTER //
// ./src/helpers/formatters.js